import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detailsContainer", "detailTemplate"]
  static values = { nextIndex: Number }

  connect() {
    if (!this.hasNextIndexValue) {
      this.nextIndexValue = this.detailsContainerTarget.querySelectorAll("[data-detail-row]").length
    }
  }

  addDetailRow(event) {
    event.preventDefault()
    const index = this.nextIndexValue
    const html = this.detailTemplateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.detailsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.nextIndexValue = index + 1
  }

  removeDetailRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-detail-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.querySelectorAll("input:not([type=hidden]), select, textarea").forEach((input) => {
        input.required = false
        input.disabled = true
      })
      row.classList.add("hidden")
      return
    }

    row.remove()
  }
}
